import Validate from './Validate';

export { Validate };



// WEBPACK FOOTER //
// ./src/common/index.js